import React from 'react'
import {NavHeadLinks} from '../../components/modules/pannelli/HeadLink';
import {MenuMobile} from '../../components/modules/pannelli/MenuMobile';
import {useThemes} from '../../components/hooks/hooks-mongoDB/useThemes';
import quizXS from '../../components/images/sparetime/quiz/intestato/TraboccoQW500.png';
import quizS from '../../components/images/sparetime/quiz/intestato/TraboccoQW800.png';
import quizM from '../../components/images/sparetime/quiz/intestato/TraboccoQW1200.png';
import quizL from '../../components/images/sparetime/quiz/intestato/TraboccoQW1600.png';
import quizXL from '../../components/images/sparetime/quiz/intestato/TraboccoQW2000.png';
import quizXXL from '../../components/images/sparetime/quiz/intestato/TraboccoQW3500.png';
import './quiz-abruzzo.scss';

function QuizAbruzzoVini() {
    const {themes} = useThemes();
    const quizTheme = themes[10];

    return (
        <section>
            {quizTheme && <NavHeadLinks title={quizTheme.name} picB={quizXS}  picS={quizS} picM={quizM} picL={quizL} picXL={quizXL} picXXL={quizXXL} />}
            {/* <Scheda cards={cards}/> */}
            <div className="accordion--map">
                {quizTheme && <div className = "container--title">
                    <h1 className = "title__top"> {quizTheme.name} </h1> 
                </div>}
            </div>
            <MenuMobile temi={themes}/>
            <div className="quiz-container">
                <div className="quiz-card">
                    <h1>🚧 Lavori in corso</h1>
                    <p>
                    Questa pagina è attualmente in costruzione.
                    Torna più tardi per vedere gli aggiornamenti.
                    </p>
                </div>
            </div>
        </section>
    )
}
export default QuizAbruzzoVini;
